export default __webpack_public_path__ + "static/media/logo.c3cbf150.svg";